import { Component, OnInit, ViewChild } from "@angular/core";
import { ConfirmationService, SelectItem } from "primeng/api";
import { ActivatedRoute, Params } from "@angular/router";
import { ListaService } from "../../../../_services/lista.service";
import { ListaItem } from "../../../../_models/lista-item";
import { Variable } from "../../../../_models/variable-sarlaft";
import { NavService } from "../../../../_services/_nav.service";
import { SarlaftService } from "../../../../_services/sarlaft.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { forkJoin } from "rxjs";
import { Location } from "@angular/common";
import { SarlaftVariablesCondicionesComponent } from "../sarlaft-variables-condiciones/sarlaft-variables-condiciones.component";

@Component({
  selector: "app-sarlaft-editar-variables",
  templateUrl: "./sarlaft-editar-variables.component.html",
  styleUrls: ["./sarlaft-editar-variables.component.css"],
})
export class SarlaftEditarVariablesComponent implements OnInit {
  carInformacionInicial: boolean = true;
  listaVariables: SelectItem[] = [];
  codigosVariables: SelectItem[] = [];
  variables: Variable[] = [];
  variable: Variable;
  formulario: FormGroup;
  lisVariables: Variable[] = [];
  guardando: boolean = false;
  conDisabled: boolean = true;
  tabCondiciones: boolean = false;
  submitted: boolean = false;
  verDetalle: boolean = false;
  agregarVariable: boolean = false;
  actualizarVariable: boolean = false;
  @ViewChild(SarlaftVariablesCondicionesComponent) sarlaftVariablesCondicionesComponent: SarlaftVariablesCondicionesComponent;

  constructor(
    private lisServicio: ListaService,
    private nav: NavService,
    private route: ActivatedRoute,
    private sarlaftServicio: SarlaftService,
    private fb: FormBuilder,
    private conServicio: ConfirmationService,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.cargaInicial();
  }

  cargaInicial() {
    this.route.url.subscribe((url) => {
      this.verDetalle = url.some(
        (segment) => segment.path === "variables-detalle"
      );
      this.agregarVariable = url.some(
        (segment) => segment.path === "variables-agregar"
      );
      this.actualizarVariable = url.some(
        (segment) => segment.path === "variables-actualizar"
      );
    });

    forkJoin(
      this.lisServicio.getMasterDetails("ListasVariablesSarlaft"),
      this.sarlaftServicio.listadorVariablesRegistradas() //REVISAR LISTADO
    ).subscribe(([lisVariables, lisVariablesRegistradas]) => {

      this.listaVariables = [];

      if (this.agregarVariable) {
        const variablesConfiguradas = new Set(lisVariablesRegistradas.map(item => item.codigoVariableSarlaft));
        const variablesNoConfiguradas = lisVariables.filter(item => !variablesConfiguradas.has(item.codigo));

        if (variablesNoConfiguradas.length !== 0) {
          variablesNoConfiguradas.map((s: ListaItem) => {
            this.listaVariables.push({ label: s.nombre, value: s.idLista });
          });
        } else {
          this.nav.setMesage(4, {
            severity: "info",
            summary: this.nav.buscarMensaje("LBL_INFORMACION"),
            detail: this.nav.buscarMensaje("SARLAFT.LBL_NOVARAIBLES"),
          });
          this.listaVariables.push({ label:'', value:null });
        }
      } else {
        lisVariables.map((s: ListaItem) => {
          this.listaVariables.push({ label: s.nombre, value: s.idLista });
        });
      }
      lisVariables.map((s: ListaItem) => {
        this.codigosVariables.push({label: s.codigo, value: s.idLista});
      });

      if (this.listaVariables.length === 0) {
        this.nav.setMesage(4, {
          severity: "info",
          summary: this.nav.buscarMensaje("LBL_INFORMACION"),
          detail: this.nav.buscarMensaje("LISTAS.MSG_NOEXISTE"),
        });
      }
      this.variables = lisVariablesRegistradas;
      // console.log("listado variables:", this.listaVariables);
      // console.log("listado variables habilitadas:", this.variables);
    });

    this.route.params.subscribe((params: Params) => {
      if (
        params["id"] !== "" &&
        params["id"] !== null &&
        params["id"] !== undefined
      ) {
        this.sarlaftServicio
          .obtenerVariablePorId(params["id"])
          .subscribe((variable) => {
            this.variable = variable;
            // console.log("Variables por id:", this.variable);
            this.conDisabled = this.variable ? false : true;
            this.cargarFormulario();
          });
      } else {
        this.cargarFormulario();
      }
    });
  }

  cargarFormulario() {
    console.log( this.verDetalle );
    console.log( this.actualizarVariable );
    this.formulario = this.fb.group({
      variable: [
        this.variable ? this.variable.idVariableSarlaft : null,
        [Validators.required],
      ],
      peso: [
        this.variable ? this.variable.peso : null,
        [Validators.required, Validators.maxLength(5)],
      ],
      valorDefecto: [
        this.variable ? this.variable.valorDefecto : null,
        [Validators.required, Validators.maxLength(5)],
      ],
      indicadorHabilitado: [
        {
          value: this.variable ? this.variable.indicadorHabilitado : true,
          disabled: this.verDetalle
        }
      ],
      indicadorDeterminante: [ {
      value: this.variable ? this.variable.indicadorDeterminante : true,
      disabled: this.verDetalle
      }],
      descripcion: [
        this.variable ? this.variable.descripcion : null,
        // [Validators.required, Validators.maxLength(200)],
      ],
    });
    this.carInformacionInicial = false;
  }

  get f() {
    return this.formulario.controls;
  }

  onSubmit() {
    this.submitted = true;
    this.guardando = true;
    if (!this.formulario.valid) {
      this.guardando = false;
      return;
    }
    const registro = this.formulario.value;
    const existe = this.variables.find(
      (x) => x.idVariableSarlaft === registro.variable
    );
    if (existe) {
      existe.idVariableSarlaft = registro.variable;
      existe.peso = registro.peso;
      existe.valorDefecto = registro.valorDefecto;
      existe.descripcion = registro.descripcion;
      existe.indicadorHabilitado = registro.indicadorHabilitado;
      existe.indicadorDeterminante = registro.indicadorDeterminante;
      this.sarlaftServicio.actualizarVariable(existe).subscribe(
        async (response) => {
          this.conDisabled = false;
          this.nav.setMesage(0, {
            severity: "success",
            summary: this.nav.buscarMensaje("LBL_INFORMACION"),
            detail: this.nav.buscarMensaje("MSG_EXITOSERVICIO"),
          });
          this.tabCondiciones = true;
          this.sarlaftVariablesCondicionesComponent.actualizarVariable(existe);
          this.guardando = false;
        },
        (error) => {
          this.guardando = false;
          console.error("Error al actualizar:", error);
          this.nav.setMesage(0, {
            severity: "info",
            summary: this.nav.buscarMensaje("LBL_ATENCION"),
            detail: this.nav.buscarMensaje("MSG_ERRORSERVICIO"),
          });
        }
      );
    } else if (!existe) {
      let item = {} as Variable;
      item.idVariableSarlaft = registro.variable;
      item.peso = registro.peso;
      item.valorDefecto = registro.valorDefecto;
      item.descripcion = registro.descripcion;
      item.indicadorHabilitado = registro.indicadorHabilitado;
      item.indicadorDeterminante = registro.indicadorDeterminante;
      this.sarlaftServicio.crearVariable(item).subscribe(
        async (response) => {
          this.variable = response;
          this.variable.codigoVariableSarlaft = this.codigosVariables.find(x => x.value === response.idVariableSarlaft).label;
          this.variable.variableSarlaft = this.listaVariables.find(x => x.value === response.idVariableSarlaft).label;
          this.conDisabled = false;
          this.nav.setMesage(0, {
            severity: "success",
            summary: this.nav.buscarMensaje("LBL_INFORMACION"),
            detail: this.nav.buscarMensaje("MSG_EXITOSERVICIO"),
          });
          this.tabCondiciones = true;
          // this.sarlaftVariablesCondicionesComponent.actualizarVariable(this.variable);
          this.guardando = false;
          this.salirGuardar();
        },
        (error) => {
          this.guardando = false;
          this.nav.setMesage(0, {
            severity: "info",
            summary: this.nav.buscarMensaje("LBL_ATENCION"),
            detail: this.nav.buscarMensaje("MSG_ERRORSERVICIO"),
          });
        }
      );
    } else {
      this.nav.setMesage(0, {
        severity: "info",
        summary: this.nav.buscarMensaje("LBL_ATENCION"),
        detail: this.nav.buscarMensaje("MSG_ERRORSERVICIO"),
      });
      this.guardando = false;
    }
    // console.log("guardado");
  }

  regresar(dirty: boolean) {
    if (dirty) {
      this.conServicio.confirm({
        message: this.nav.buscarMensaje("MSG_CANCELARCAMBIOS"),
        header: this.nav.buscarMensaje("LBL_CONFIRMACION"),
        icon: "fa fa-question-circle",
        accept: () => {
          this.location.back();
        },
        reject: () => {},
      });
    } else {
      this.location.back();
    }
  }

  reiniciarForm() {
    this.submitted = false;
    this.formulario.markAsPristine();
    this.cargarFormulario();
  }

  salirGuardar() {
    this.nav.setMesage(1);
    this.submitted = false;
    // this.editando = false;
    this.formulario.markAsPristine();
    this.cargarFormulario();
    this.cargaInicial();
  }
}
